import styled, { css } from 'styled-components';
import { SwatchRoot } from '@gcc/pip-components/dist/Swatch/styles';

export const SwatchOverride = styled.div`
  ${SwatchRoot} {
    border-radius: 3px;
    ${({ selected }) => (selected ? css`border: 2px solid #f96302` : css`border: 1px solid #ccc`)};

    img {
      padding: 3px;
      border - radius: 3px;
    }
  
    & > span:after {
      content: none;
    }
  }
`;

export const OptionWrapper = styled.div.attrs({ className: 'tiles-option' })`
  font-size: 14px;
  strong {
    font-weight: bold !important;
  }
`;